"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, ShieldCheck, Clock, FileCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const trustIndicators = [{
  id: "eval",
  label: "Evaluación técnica preliminar",
  icon: ShieldCheck
}, {
  id: "time",
  label: "Respuesta en menos de 48 horas",
  icon: Clock
}, {
  id: "scope",
  label: "Alcance normativo garantizado",
  icon: FileCheck
}];
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="llamado-a-la-acción" data-nav="dark" className="dark bg-background text-foreground relative py-20 lg:py-28 overflow-hidden border-t border-border">
      <div className="container mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} variants={containerVariants} className="relative mx-auto max-w-4xl rounded-md border border-border/70 bg-card/60 p-8 md:p-14 lg:p-16 text-center shadow-lg">
          {/* Subtle gold decorative top bar */}
          <div className="mx-auto mb-6 h-[1.5px] w-12 bg-ring" />

          {/* Eyebrow badge */}
          <p className="font-serif text-xs md:text-sm font-semibold tracking-widest uppercase text-ring mb-4">
            Estrategia · Cumplimiento · Resultados
          </p>

          {/* Main heading */}
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-semibold tracking-wide text-foreground uppercase max-w-2xl mx-auto leading-tight">
            Solicita una propuesta institucional para tu organización
          </h2>

          {/* Subline */}
          <p className="font-sans text-base md:text-lg text-muted-foreground mt-4 mb-8 max-w-2xl mx-auto leading-relaxed">
            Evaluamos el alcance normativo y operativo de tu dependencia o empresa para entregarte un plan de trabajo concreto con atención directa de especialistas senior.
          </p>

          {/* Action Button */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto font-serif tracking-wider uppercase text-xs font-semibold px-8 py-6 rounded-xs bg-primary text-primary-foreground border border-ring hover:bg-ring hover:text-primary transition-[color,background-color,border-color] duration-200">
              <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2">
                <span>Solicitar cotización</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto font-serif tracking-wider uppercase text-xs font-semibold px-8 py-6 rounded-xs border-ring text-ring hover:bg-ring/10 hover:text-ring transition-[color,background-color,border-color] duration-200">
              <Link to="/OnlineConsultingPage">
                Hablar con un especialista
              </Link>
            </Button>
          </div>

          {/* Trust points */}
          <div className="mt-12 pt-8 border-t border-border/50 grid grid-cols-1 md:grid-cols-3 gap-6">
            {trustIndicators.map((item, i) => {
            const IconComponent = item.icon;
            return <div key={item.id} data-index={i} className="flex items-center justify-center gap-2.5 text-xs text-muted-foreground">
                  <IconComponent className="size-4 text-ring shrink-0" />
                  <span className="font-sans">{item.label}</span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}